/* import __COLOCATED_TEMPLATE__ from './content.hbs'; */
/**

## Selector Control Content

**Contextual Component** This component is not intended to be used as a standalone. Checkout it's potential parent components for usage instead:
- [Selector Control](../selector-control.html)

Selector Content is a simple yielded block component determines whether it's block contents should be visible
on the page according to the currently selected item from within a [Selector Control component](../selector-control.html)

This component is not designed for use outside the [Selector Control component](../selector-control.html), and
purposefully does not include examples. See [Selector Control component](../selector-control.html) for
examples and usage.

### Parameters
@param {String} [currentItem] Unique identifier (key or label) of the item's content that should be visible

*/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['selector-control__content'],
  attributeBindings: ['data-test-selector-control-content', 'id'],
  'data-test-selector-control-content': true,
  id: 'selector-control-content'
});